import { render, staticRenderFns } from "./LetterContainer.vue?vue&type=template&id=19728fd0&scoped=true"
import script from "./LetterContainer.vue?vue&type=script&lang=js"
export * from "./LetterContainer.vue?vue&type=script&lang=js"
import style0 from "./LetterContainer.vue?vue&type=style&index=0&id=19728fd0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19728fd0",
  null
  
)

export default component.exports